import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="device-check-files"
// Image-only dropzone that auto-submits its form once files are dropped or chosen.
export default class extends Controller {
  static targets = ["input"]

  openDialog() {
    this.inputTarget.click()
  }

  dragover(event) {
    event.preventDefault()
    this.element.classList.add("!border-secondary-700", "bg-secondary-50")
  }

  dragleave(event) {
    if (!this.element.contains(event.relatedTarget)) {
      this.element.classList.remove("!border-secondary-700", "bg-secondary-50")
    }
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove("!border-secondary-700", "bg-secondary-50")

    const images = Array.from(event.dataTransfer.files).filter((file) => file.type.startsWith("image/"))
    if (images.length === 0) return

    const data = new DataTransfer()
    images.forEach((file) => data.items.add(file))
    this.inputTarget.files = data.files
    this.submit()
  }

  submit() {
    if (this.inputTarget.files.length > 0) this.element.requestSubmit()
  }
}
